import script from "./CheckBoxFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckBoxFeatures.vue?vue&type=script&setup=true&lang=js"

import "./CheckBoxFeatures.vue?vue&type=style&index=0&id=90de6614&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90de6614"]])

export default __exports__